import useMediaQuery from '@material-ui/core/useMediaQuery';

/**
 * The dashboard has 2 things that take up a lot of width - the pillar progress and the action items.
 * It looks bad on desktop to use the normal definition of mobile, so here's a custom definition of mobile just for this page
 */
export function useMobileLayoutForDashboardOnlyDoNotUseElsewhere() {
  return useMediaQuery('@media (max-width: 1200px)');
}
